import { jsx as _jsx } from "react/jsx-runtime";
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { useConfigurationState } from 'z3k-settings/climatic/configuration/lib/useConfigurationState';
import { DhwCard } from 'z3k-settings/climatic/configuration/ui/dhw-card';
export function DhwList() {
    const { dhw } = useConfigurationState();
    return (_jsx(SettingCard, { title: "\u041A\u043E\u043D\u0442\u0443\u0440 \u0413\u0412\u0421", children: dhw.map((dhw, i) => (_jsx(DhwCard, { dhw_settings: dhw }, dhw.id))) }));
}
